import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useNewResourceTypeMutation } from "../../services/appln";
import ErrorMsg from "../../components/ErrorMsg";

interface FormData {
  name: string;
  desc: string;
}

interface Props {
  onSubmitHandler: (newObj: any) => void;
  onCancelHandler: () => void;
  state: boolean;
}

export default function NewResourceType(props: Props) {
  const [createResourceType, createResourceTypeParams] =
    useNewResourceTypeMutation();

  const iv: FormData = {
    name: "",
    desc: "",
  };

  const onCancelHandlerWrapper = () => {
    createResourceTypeParams.reset();
    props.onCancelHandler();
  };

  console.log(
    "NewResourceType, createResourceTypeParams:",
    createResourceTypeParams,
  );
  React.useEffect(() => {
    if (createResourceTypeParams.isSuccess) {
      props.onSubmitHandler(createResourceTypeParams.data.id);
    }
  }, [createResourceTypeParams]);

  return (
    <div>
      <Dialog
        open={props.state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.newResourceType}
        </DialogTitle>
        {createResourceTypeParams.isError && (
          <ErrorMsg msg={strings.failedToCreateResourceType} />
        )}
        {createResourceTypeParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.name) {
                errors.name = strings.nameMandatory;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              createResourceType(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="name"
                        name="name"
                        label={strings.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        margin="normal"
                        multiline
                        rows={3}
                        id="desc"
                        name="desc"
                        label={strings.desc}
                        value={values.desc}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.desc && Boolean(errors.desc)}
                        helperText={touched.desc && errors.desc}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.create}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={onCancelHandlerWrapper}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
